<template>
  <div>
    <v-dialog v-model="meterDialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          {{
          event == "create" ? $t('meter.add_meter') : $t('meter.edit_meter')
          }}
        </v-card-title>
        <v-card-text class="py-5">
          <v-text-field
            :label="$t('meter.meter_name')"
            v-model="form.name"
            outlined
          ></v-text-field>
          <AutocompleteArea
            :items="$store.getters['markets/getAreas']"
            v-model="form.areaId"
            chip
            outlined
          />
          <!-- <v-autocomplete
           
            item-text="name"
            item-value="objectId"
            label="เพิ่มไปยังแผง"
            dense
            solo
            flat
            background-color="grey lighten-4"
           
          ></v-autocomplete>-->
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="meterDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            :disabled="type != 'elec' && type != 'water' || form.name == '' || form.areaId == ''"
            @click="onSave"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AutocompleteArea from "./AutocompleteArea.vue";
export default {
  name: "PageName",
  components: {
    AutocompleteArea
  },
  computed: {
    meterDialog: {
      get() {
        this.form = {
          name: "",
          areaId: ""
        };
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {},
  data() {
    return {
      form: {
        name: "",
        areaId: ""
      }
    };
  },
  props: {
    value: Boolean,
    event: String,
    type: String
  },
  methods: {
    onSave() {
      this.meterDialog = false;
      this.$emit("onSave", this.form);
      this.form = {
        name: "",
        areaId: ""
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
